import Main from './Main'
import Lista from './components/BemEquipamento'
import Novo from './components/NovoBemEquipamento'

export default [
  {
    path: 'bem-equipamento',
    name: 'config.bem-equipamento',
    component: Main,
    redirect: { name: 'config.bem-equipamento.list' },
    children: [
      {
        path: '/',
        name: 'config.bem-equipamento.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.bem-equipamento.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.bem-equipamento.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/bem-equipamento/routes.js